const { pickBy, findKey, sortBy, isEmpty, } = require('lodash');

const { taxRates } = require('../config');

const { entries } = Object;

const fields = (productTags = [], { hasChildren = false } = {}) => {
  return {
    name: {
      type: 'string',
      label: '商品名',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    unitCost: {
      type: 'integer',
      label: '原価単価(税込)',
      hint: '原価改定日を登録していない期間はこの単価で計算されます',
      hidden: _ => hasChildren,
      validations: {},
    },
    costTaxRate: {
      type: 'select',
      label: '原価税率',
      hidden: _ => hasChildren,
      options: entries(taxRates).map(([k, v]) => ({ value: k, label: v.label })),
      initialValue: 'tax10',
    },
    unitShippingCost: {
      type: 'integer',
      label: '配送料単価(税込)',
      hidden: _ => hasChildren,
      validations: {},
    },
    unitCostHistory: {
      type: 'list',
      label: '原価改定履歴',
      hint: '原価が変わった日付と単価を登録すると、その日以降・次の改定日の前まではその単価で利益計算されます',
      hidden: _ => hasChildren,
      initialValue: [],
    },
    tagIds: {
      type: 'multiSelect',
      label: 'タグ',
      options: productTags.map(_ => ({ value: _.id, label: _.name })),
      initialValue: [],
    },
  };
};

// 原価改定履歴の1エントリ分のフォーム定義（ListForm で繰り返し表示する）
const unitCostHistoryItemFields = () => {
  return {
    effectiveDate: {
      type: 'date',
      label: '適用開始日',
      validations: {
        required: v => v != null,
      },
    },
    unitCost: {
      type: 'integer',
      label: '原価単価(税込)',
      validations: {
        required: v => v != null,
      },
    },
  };
};

exports.fields = fields;
exports.unitCostHistoryItemFields = unitCostHistoryItemFields;
